export enum Permission {
  StoreConfigsView = 'store_configs.view',
  StoreConfigsModify = 'store_configs.modify',
  AdminStorefrontSetupView = 'admin_storefront_setup.view',
  OnboardingAdminStorefrontSetupView = 'onboarding_admin_storefront_setup.view',
  StorefrontOnboardingAdminStorefrontSetupView = 'storefront_onboarding_admin_storefront_setup.view',
}
